import { LOGOS, LOGO_DISCLAIMER } from "@/data/content";

export default function LogoWall({ heading = "Trusted engagements across our capability space" }) {
  return (
    <section className="m61-section border-t border-m61-line bg-m61-surface/40" data-testid="logo-wall">
      <div className="m61-container">
        <h2 className="m61-h2 mb-12 max-w-2xl">{heading}</h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {LOGOS.map((logo) => (
            <div
              key={logo.file}
              className="rounded-xl bg-white flex items-center justify-center p-5 lg:p-6 aspect-[3/2] border border-m61-line transition-transform duration-300 hover:-translate-y-1"
              title={logo.name}
            >
              <img
                src={`/logos/${logo.file}`}
                alt={logo.name}
                loading="lazy"
                className="max-h-12 lg:max-h-14 w-auto max-w-full object-contain"
              />
            </div>
          ))}
        </div>
        <p className="mt-6 text-sm text-m61-muted max-w-3xl" data-testid="logo-disclaimer">
          {LOGO_DISCLAIMER}
        </p>
      </div>
    </section>
  );
}
